import gql from 'graphql-tag';

const WDT_ACTIVE_STUDENT_REPORT_QUERY = gql`
  query wdtActiveStudentsReport(
    $where: WdtActiveStudentsReportWhereInput!
    $dateRange: DateRangeInput!
  ) {
    wdtActiveStudentsReport(where: $where, dateRange: $dateRange) {
      activeStudentCount
      totalStudentCount
    }
  }
`;

export default WDT_ACTIVE_STUDENT_REPORT_QUERY;
